<template>
  <div class="container round px-0 mb-5">
    <div class="page-header mb-1">
      <strong>โพยถูกรางวัล</strong>
    </div>
    <div v-if="roundId" class="card">
      <RoundCardHeader />
      <div v-if="isAvailable" class="card-body p-0">
        <table class="table table-sm table-bordered table-striped table-hover mb-0">
          <thead>
            <tr>
              <th width="60">ลำดับ</th>
              <th width="200">วันที่</th>
              <th width="15%">สมาชิก</th>
              <th width="15%">ยอดแทง</th>
              <th width="15%">ถูกรางวัล</th>
              <th>หมายเหตุ</th>
              <th width="15%">สถานะ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="item._id">
              <td class="text-center">{{ index+1 }}</td>
              <td class="text-center">{{ item.createdAt | dispDateTime("YYYY-MM-DD HH:mm:ss") }}</td>
              <td class="text-center">{{item.account.mainUser.username}}</td>
              <td class="text-right">{{item.summary.amount | amountFormat(2)}}</td>
              <td class="text-right text-success">{{item.summary.won | amountFormat(2)}}</td>
              <td class="text-center">{{item.remarks}}</td>
              <td class="text-center"><TicketStatus :ticket="item" /></td>
            </tr>
            <tr v-if="!items.length">
              <td colspan="7" class="text-center">ไม่มีโพยถูกรางวัล</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="3" class="text-center">รวม</th>
              <th class="text-right">{{ summary.amount | amountFormat(2) }}</th>
              <th class="text-right text-success">{{ summary.won | amountFormat(2) }}</th>
              <th colspan="2" class="text-center"></th>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="card-body">
        <div class="alert alert-warning mb-0">ยังไม่ได้ออกผล</div>
      </div>
    </div>
    <div v-else class="card">
      <div class="card-body">กรุณาเลือกงวดหวย</div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import LottoService from '@/services/lottoService'
import RoundCardHeader from './components/RoundCardHeader'
import TicketStatus from '@/views/components/TicketStatus'

export default {
  name: 'WonTickets',
  components: {
    RoundCardHeader,
    TicketStatus
  },
  data() {
    return {
      round: null,
      data: null
    }
  },
  computed: {
    roundId() {
      return this.$store.state.globalMarket.round.roundId
    },
    items() {
      return this.data?.tickets || []
    },
    status() {
      return this.round?.status
    },
    isAvailable() {
      return ['Complete', 'Paid'].includes(this.status)
    },
    summary() {
      return this.items.reduce((total, item)=>{
        total.amount += item.summary.amount
        total.won += item.summary.won
        return total
      }, {
        amount: 0,
        won: 0
      })
    }
  },
  watch: {
    roundId() {
      if(this.roundId) {
        this.getTickets()
      }
    }
  },
  methods: {
    getTickets() {
      LottoService.getWonTickets(this.roundId).then((response)=>{
        if(response.success) {
          this.data = response.data
          this.round = response.data.round
        }else{
          throw new Error(response?.message || JSON.stringify(response?.data))
        }
      })
      .catch((e)=>{
        Swal.fire({
          title: 'ผิดพลาด!',
          text: (e?.message || e?.data) || 'กรุณาลองใหม่อีกครั้ง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
    }
  },
  mounted() {
    this.getTickets()
  }
}
</script>
<style lang="scss" scoped>
.table {
  border: 0;

  thead {
    tr {
      th {
        font-size: 90%;
        text-align: center;
      }
    }
  }

  tr {
    th {
      border-top: 0;
      vertical-align: middle;
    }

    td {
      vertical-align: middle;
      font-size: 90%;
    }
  }

  tr {
    td:first-child,
    th:first-child {
      border-left: 0;
    }
    td:last-child,
    th:last-child {
      border-right: 0;
    }
  }
}
</style>
